import { Component, Input, OnInit, Output } from "@angular/core";
import { UnsubscribeComponent } from "../../../../generals/Components";
import { takeUntil } from "rxjs/operators";
import { AdminModuleDetail, ModulePaymentSimplepayConfig } from "../../../../interfaces/interfaces";
import { ApiService } from "../../../../services/api.service";
import { EventEmitter } from "@angular/core";

@Component({
    selector: 'app-paymentsimplepay',
    templateUrl: './paymentsimplepay.component.html',
    styleUrls: ['./paymentsimplepay.component.scss']
})
export class PaymentSimplepayModuleComponent extends UnsubscribeComponent implements OnInit {
    
    @Input() module: AdminModuleDetail<ModulePaymentSimplepayConfig> = null;
    config: ModulePaymentSimplepayConfig = null;

    @Output() inited: EventEmitter<boolean> = new EventEmitter();
    @Output() configChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private apiService: ApiService
    ) {
        super();
    }

    ngOnInit(): void {
        this.inited.emit(true);
        this.config = { ...this.module.config };
    }

    configChangedEvent(): void {
        this.configChanged.emit(true);
    }

    saveConfig(): void {
        this.apiService.saveModuleConfig(this.module.id, this.config).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.configChanged.emit(false);
        });
    }

}